export default {
  sm: 540,
  md: 768,
  lg: 1024,
  xl: 1440
}
